import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import qs from 'qs';
// import { ClientMethodTypes } from 'models/Client.model';

export class HttpClient {
    client: AxiosInstance = null;

    constructor(options: AxiosRequestConfig) {
        this.client = axios.create(options);
    }

    async getHeaders() {
        const headers = {
            // cookie: process.env.REACT_APP_SET_COOKIE,
            // 'OAuth-code': process.env.REACT_APP_OAUTH_CODE,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Accept: '*/*',
        };
        return headers;
    }

    async createRequest(config) {
        try {
            return await this.client.request(config);
        } catch (error) {
            console.error('CSRF error:', error);
            throw error;
        }
    }

    async get(url, config) {
        return this.createRequest({
            url: this.getCorsURL(url),
            ...config,
            method: 'GET',
            headers: await this.getHeaders(),
            withCredentials: false,
        });
    }

    async post(url, data, config) {
        return this.createRequest({
            ...config,
            url: this.getCorsURL(url),
            data: qs.stringify(data),
            method: 'POST',
            headers: {
                ...(await this.getHeaders()),
                ...(config?.headers || {}),
            },
            withCredentials: true,
        });
    }

    async patch(url, data, config) {
        return this.createRequest({
            ...config,
            url: this.getCorsURL(url),
            data,
            method: 'PATCH',
            headers: await this.getHeaders(),
            withCredentials: true,
        });
    }

    async put(url, data, config) {
        return this.createRequest({
            ...config,
            url: this.getCorsURL(url),
            data,
            method: 'PUT',
            headers: await this.getHeaders(),
            withCredentials: true,
        });
    }

    async delete(url, config) {
        return this.createRequest({
            ...config,
            url: this.getCorsURL(url),
            method: 'DELETE',
            headers: await this.getHeaders(),
            withCredentials: true,
        });
    }

    private getCorsURL(path: string): string {
        return process.env.REACT_APP_CORS_URL
            ? `${process.env.REACT_APP_CORS_URL}${process.env.REACT_APP_CORS_PATH}${path}`
            : path;
    }
}
